var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Aba",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome de Exibição",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.nomeDeExibicao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nomeDeExibicao", $$v);
      },
      expression: "form.filters.nomeDeExibicao"
    }
  })], 1), _c('sigfoco-select-ativo', {
    attrs: {
      "cols": 3,
      "labelType": "Situação"
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarAbas();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterAba();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listAbas,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nome) + " ")];
      }
    }, {
      key: `item.nomeDeExibicao`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.nomeDeExibicao) + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarAba(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterAba(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Excluir',
            "icon": 'mdi-delete',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.excluirAba(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "color": `${item.ativo ? 'var(--primary-button-color)' : 'silver'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarAba(item);
            }
          }
        })];
      }
    }, {
      key: `item.emUso`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Detalhar Uso',
            "icon": item.emUso ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline',
            "color": item.emUso ? 'green' : 'red',
            "small": true,
            "disabled": !item.emUso
          },
          on: {
            "click": function ($event) {
              item.emUso ? _vm.openDialogDetalharUsoAba(item) : null;
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarAbasDialog', {
    attrs: {
      "visible": _vm.dialogManterAba.visible,
      "content": _vm.dialogManterAba.content,
      "edit": _vm.dialogManterAba.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterAba.close();
      },
      "onSave": function ($event) {
        return _vm.buscarAbas();
      }
    }
  }), _c('VisualizarAbasDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarAba.visible,
      "content": _vm.dialogVisualizarAba.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarAba.close();
      }
    }
  }), _c('DetalharUsoAbaDialog', {
    attrs: {
      "visible": _vm.dialogDetalharUsoAba.visible,
      "content": _vm.dialogDetalharUsoAba.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogDetalharUsoAba.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }